/**
 * specKey.ts
 *
 * Frontend helper for deterministic serialization of structured material specifications (H1).
 * Mirrors server/src/services/bomAdapter/specKey.ts.
 */

export function normalizeSpecValue(val: unknown): unknown {
  if (val === null || val === undefined) return undefined
  if (typeof val === 'string') {
    const trimmed = val.trim()
    return trimmed === '' ? undefined : trimmed
  }
  if (typeof val === 'number') {
    return Number.isFinite(val) ? val : undefined
  }
  if (typeof val === 'boolean') {
    return val
  }
  if (Array.isArray(val)) {
    const cleanedArr = val
      .map(normalizeSpecValue)
      .filter((v) => v !== undefined)
    return cleanedArr.length > 0 ? cleanedArr : undefined
  }
  if (typeof val === 'object') {
    const keys = Object.keys(val as Record<string, unknown>).sort()
    const cleanedObj: Record<string, unknown> = {}
    let hasKeys = false
    for (const k of keys) {
      const cleanedV = normalizeSpecValue((val as Record<string, unknown>)[k])
      if (cleanedV !== undefined) {
        cleanedObj[k] = cleanedV
        hasKeys = true
      }
    }
    return hasKeys ? cleanedObj : undefined
  }
  return undefined
}

export function serializeSpecKey(
  spec?: Record<string, unknown> | string | null,
): string {
  if (!spec) return ''
  if (typeof spec === 'string') {
    const trimmed = spec.trim()
    return trimmed ? JSON.stringify({ spec_raw: trimmed }) : ''
  }
  if (typeof spec !== 'object') return ''
  const normalized = normalizeSpecValue(spec)
  if (!normalized || typeof normalized !== 'object' || Object.keys(normalized).length === 0) {
    return ''
  }
  return JSON.stringify(normalized)
}
